import React from 'react'
import { InputMask } from 'primereact/inputmask'

export default function InputPhone({
  value,
  onChange,
  label,
  labelColor = '#14B0BF',
  width = '100%',
  marginTop = 20,
  disabled = false,
  autoClear = true,
  mask = '(99)99999-9999',
}) {
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: labelColor,
      display: 'block',
    },
    input: {
      width,
      outline: 'none',
      border: '1px solid  #F1F1F1',
      borderRadius: 3,
      height: 30,
      marginTop: 3,
      padding: 10,
    },
  }

  return (
    <div style={styles.container}>
      <label style={styles.label} htmlFor="myInput">
        {label}
      </label>
      <InputMask
        disabled={disabled}
        autoClear={autoClear}
        style={styles.input}
        mask={mask}
        value={value}
        onChange={e => onChange(e.value)}
      ></InputMask>
    </div>
  )
}
